module.exports = __webpack_public_path__ + "static/media/ic-category-notice-off.2db23f1f.svg";